import { api } from "@api/api";
import { Level } from "@modules/levels/types";
import { LevelFormValues } from "@modules/levels/validations";

export async function editLevelService(id: string, data: Partial<LevelFormValues>): Promise<Level> {
  const { data: level } = await api.patch<Level>(`v1/level_admin/${id}/`, data);

  return level;
}
